export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/c5d6534f4f2cb925009575e748220704.svg";